export default __webpack_public_path__ + "static/media/location-icon2.c9a22f60.png";